/**
 * Enumeración que representa los tipos de tarjeta disponibles.
 *
 * @enum {string}
 * @property {string} Redes - Representa una tarjeta de tipo Redes.
 * @property {string} Blog - Representa una tarjeta de tipo Blog.
 */
export enum TipoTarjeta {
  Redes = "Redes",
  Blog = "Blog",
}
